export default {
  REDIRECT_TO: 'REDIRECT_TO',
}